module.exports = {
  UPDATE_LANGUAGE: 'UPDATE_LANGUAGE',
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
};
